import { useKeenSlider } from "keen-slider/react";
import { FC, useEffect } from "react";
import "keen-slider/keen-slider.min.css";

interface Props {
    inView: boolean;
    data: Array<{
        id: number;
        title: string;
        description: string;
        imageSrc: string;
        delay: number;
    }>;
}

const SliderView: FC<Props> = ({ inView, data }) => {
    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        vertical: true,
        slides: { perView: "auto" }
    });

    useEffect(() => {
        const timeout = setInterval(() => {
            inView && instanceRef.current?.next();
        }, 2000);

        return () => {
            clearInterval(timeout);
        };
    }, [inView]);

    return (
        <div className="slider-section">
            <div ref={sliderRef} className="keen-slider">
                {data.map((slide) => (
                    <img
                        key={slide.id}
                        className="keen-slider__slide"
                        src={slide.imageSrc}
                        alt={`slide-${slide.id}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default SliderView;
